import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';

import GameDetailsForm from './GameDetailsForm/GameDetailsForm';

const GameDetails: React.FC = () => (
  <StarsWizard.Page name="GameDetails">
    <GameDetailsForm />
  </StarsWizard.Page>
);

GameDetails.displayName = 'GameDetails';

export default GameDetails;
